"use client";

import type { ReactNode } from "react";

import { AddPostFloatingButton } from "@/components/app/app-layout/add-post-floating-button";
import { IsLoggedIn } from "@/components/shared/is-logged-in";
import { useLayout } from "@/contexts/layout-context";

import { MobileNavigation } from "./layout-navigation-mobile";

interface LayoutMiddleProps {
  children: ReactNode;
}

export const AppLayoutMain = ({ children }: LayoutMiddleProps) => {
  const { floatingPostButton, hideMobileNav } = useLayout();

  return (
    <>
      <div>{children}</div>
      {!hideMobileNav && <MobileNavigation />}
      <IsLoggedIn>{floatingPostButton && <AddPostFloatingButton />}</IsLoggedIn>
    </>
  );
};
